<div class="row px-0 mx-0 justify-content-between">
  <p *ngIf="input.QueovalCode === 'PLMINMAX'" class="col-1 mx-0 px-0 text-center">De</p>
  <p *ngIf="input.QueovalCode === 'TXTCPL'" class="col-2 mx-0 px-0 text-center">Valeur 1</p>

  <input [id]="input.MainElementList[0].ID" [attr.type]="input.QueovalCode === 'PLMINMAX'?'number':'text'" class="h-100 q-input-no-border col-3 mx-0"
         [disabled]="input.MainElementList[0].Disabled"
         [(ngModel)]="val1" (change)="setCouple(val1, val2)"
         [ngClass]="setClass(input)">

  <p *ngIf="input.QueovalCode === 'PLMINMAX'" class="col-1 mx-0 px-0 text-center">à</p>
  <p *ngIf="input.QueovalCode === 'TXTCPL'" class="col-2 mx-0 px-0 ml-2 text-center">Valeur 2</p>

  <input [id]="input.MainElementList[0].ID" [attr.type]="input.QueovalCode === 'PLMINMAX'?'number':'text'" class="h-100 q-input-no-border col-3 mx-0"
         [disabled]="input.MainElementList[0].Disabled"
         [(ngModel)]="val2" (change)="setCouple(val1, val2)"
         [ngClass]="setClass(input)">
</div>

<!--<div class="row px-0 mx-0 justify-content-between">
  <p *ngIf="input.QueovalCode === 'PLMINMAX'" class="col-1 mx-0 px-0 text-center">De</p>
  <p *ngIf="input.QueovalCode === 'TXTCPL'" class="col-2 mx-0 px-0 text-center">Valeur 1</p>

  <input [id]="input.MainElementList[0].ID" [attr.type]="input.QueovalCode === 'PLMINMAX'?'number':'text'" class="h-100 q-input-no-border col-3 mx-0"
         [disabled]="input.MainElementList[0].Disabled"
         [(ngModel)]="val1" (change)="setCouple(val1, val2)"
         [ngClass]="{'q-input-required':input.MainElementList[0].Required === 'require',
         'q-input-novalid':input.MainElementList[0].Required === 'novalid',
         'input-disabled':input.MainElementList[0].Disabled}">

  <p *ngIf="input.QueovalCode === 'PLMINMAX'" class="col-1 mx-0 px-0 text-center">à</p>
  <p *ngIf="input.QueovalCode === 'TXTCPL'" class="col-2 mx-0 px-0 ml-2 text-center">Valeur 2</p>

  <input [id]="input.MainElementList[0].ID" [attr.type]="input.QueovalCode === 'PLMINMAX'?'number':'text'" class="h-100 q-input-no-border col-3 mx-0"
         [disabled]="input.MainElementList[0].Disabled"
         [(ngModel)]="val2" (change)="setCouple(val1, val2)"
         [ngClass]="{'q-input-required':input.MainElementList[0].Required === 'require',
         'q-input-novalid':input.MainElementList[0].Required === 'novalid',
         'input-disabled':input.MainElementList[0].Disabled}">
</div>-->
